export const selectSession = (state) => state.session;
export const selectUser = (state) => state.session.user;
export const selectLoginDetail = (state) => state.session.login_detail;
export const selectSessionRefetched = (state) =>
  state.session.sessionsRefetched;
